var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLockNewinline = function SvgLockNewinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#21201F",
    strokeMiterlimit: 10,
    d: "M15.058 7.65H4.942c-.603 0-1.092.489-1.092 1.092V17.5c0 .603.489 1.092 1.092 1.092h10.115c.604 0 1.093-.489 1.093-1.092V8.742c0-.603-.489-1.092-1.092-1.092ZM6.076 6.512V5.395a3.971 3.971 0 0 1 7.942 0v1.072M10.047 10.968v3.955"
  })));
};
export default SvgLockNewinline;